import baseRequest from "../_core/baseRequest";

export default {
    //Equipment Types
    listEquipmentTypes: params => baseRequest.get(`/equipment/listTypes`, params),
    createEquipmentType: params => baseRequest.post(`/equipment/createType`, params),
    updateEquipmentType: params => baseRequest.post(`/equipment/updateType`, params),
    deleteEquipmentType: params => baseRequest.post(`/equipment/deleteType`, params),

    //Equipments
    listEquipments: params => baseRequest.post(`/equipment/list`, params),
    getEquipment: params => baseRequest.get(`/equipment/get/${params?.id || ""}`, params),
    createEquipment: params => baseRequest.post(`/equipment/create`, params),
    updateEquipment: params => baseRequest.post(`/equipment/update`, params),
    deleteEquipment: params => baseRequest.post(`/equipment/delete`, params),
    listAllEquipments: params => baseRequest.get(`/equipment/listAll`, params),

    //Courier Equipments
    listCourierEquipments: params => {
        const queryParams = new URLSearchParams();
        if (params?.limit) queryParams.append("limit", params.limit);
        if (params?.page) queryParams.append("page", params.page);
        if (params?.skip) queryParams.append("skip", params.skip);
        if (params?.zoneId) queryParams.append("zoneId", params.zoneId);
        if (params?.equipmentTypeId) queryParams.append("equipmentTypeId", params.equipmentTypeId);
        if (params?.preferredCityId) queryParams.append("preferredCityId", params.preferredCityId);
        if (params?.contractStatus) queryParams.append("contractStatus", params.contractStatus);
        if (params?.assignmentStatus)
            queryParams.append("assignmentStatus", params.assignmentStatus);
        if (params?.searchText) queryParams.append("searchText", params.searchText);
        if (params?.courierActivity) queryParams.append("courierActivity", params.courierActivity);
        if (params?.activationStep) queryParams.append("activationStep", params.activationStep);
        if (params?.handoveredStartDate)
            queryParams.append("handoveredStartDate", params.handoveredStartDate);
        if (params?.handoveredEndDate)
            queryParams.append("handoveredEndDate", params.handoveredEndDate);
        if (params?.employmentType) queryParams.append("employmentType", params.employmentType);

        const queryString = queryParams.toString()?.replaceAll("+", "%20");
        return baseRequest.get(`/courier-equipment/list${queryString ? `?${queryString}` : ""}`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    exportCourierEquipments: params => {
        const queryParams = new URLSearchParams();
        if (params?.zoneId) queryParams.append("zoneId", params.zoneId);
        if (params?.equipmentTypeId) queryParams.append("equipmentTypeId", params.equipmentTypeId);
        if (params?.preferredCityId) queryParams.append("preferredCityId", params.preferredCityId);
        if (params?.contractStatus) queryParams.append("contractStatus", params.contractStatus);
        if (params?.assignmentStatus)
            queryParams.append("assignmentStatus", params.assignmentStatus);
        if (params?.searchText) queryParams.append("searchText", params.searchText);
        if (params?.courierActivity) queryParams.append("courierActivity", params.courierActivity);
        if (params?.activationStep) queryParams.append("activationStep", params.activationStep);
        if (params?.handoveredStartDate)
            queryParams.append("handoveredStartDate", params.handoveredStartDate);
        if (params?.handoveredEndDate)
            queryParams.append("handoveredEndDate", params.handoveredEndDate);
        if (params?.employmentType) queryParams.append("employmentType", params.employmentType);

        const queryString = queryParams.toString()?.replaceAll("+", "%20");
        return baseRequest.get(
            `/courier-equipment/export${queryString ? `?${queryString}` : ""}`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            true
        );
    },
    courierEquipmentDetail: params =>
        baseRequest.get(`/courier-equipment/details/${params?.id || ""}`, params),
    assignEquipmentToMultipleCouriers: params =>
        baseRequest.post(`/courier-equipment/assign-multiple`, params),
    returnEquipmentFromCourier: params => baseRequest.post(`/courier-equipment/return`, params),
    completeEquipmentAssignment: params =>
        baseRequest.post(`/courier-equipment/complete-equipment-assignment`, params),
    deleteWaitingAssignmentEquipment: params =>
        baseRequest.post(`/courier-equipment/delete-waiting-assignment-equipment`, params),
    rejectCourierEquipmentContract: params =>
        baseRequest.post(`/courier-equipment/reject-contract`, params)
};
